<micro-select-combo #sel
              placeholder="Chat Carrier Type"
              valueField="id"
              [mode]="mode"
              [(id)]="chatCarrierType"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
